<template lang="pug">
  div
    section.content-header
      h1 組織情報のエクスポート

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'group'}") 組織管理
        li.active 組織情報のエクスポート

    section.content

      app-messages(:errorMessages="$store.state.base.flashMessages")
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="exportAction()")
        mixin btnbar
          .bcard-btnbar.clearfix.text-left(class!=attributes.class)
            router-link.btn.btn-default(:to="{name: 'group'}" title="戻る"): i.fa.fa-reply
            |
            |
            button.btn.btn-primary(type="submit") エクスポート

        +btnbar

        .box.box-widget
          .box-header.with-border
            .box-title 項目の順番
          .box-body
            .form-group
              .bcard-btnbar
                button.btn.btn-default(type="button" @click.prevent="resetImexfld") 既定値に戻す
              .table-responsive.bcard-table-container
                table.table.table-bordered.table-hover
                  draggable(v-model="imexfld", element="tbody")
                      tr(v-for="fld in imexfld", :key="fld.value")
                        td
                          input.form-control(type="hidden", name="imexfld[]", :value="fld.value")
                          i.fa.bcard-fa-grip
                          | &nbsp;{{fld.name}}

        .box.box-widget
          .box-body
            .form-horizontal
              export-settings(ref="exportSettings")
              .form-group
                label.col-sm-3.control-label 「親組織」項目の値
                .col-sm-6
                  select.form-control(v-model="groupvalkind", name="groupvalkind")
                    option(value="i") 組織システムID (例 : *246)
                    option(value="o") 企業内組織コード (例 : @NEO0001)
                    option(value="n") 組織名 (例 : 情報システム室)
                  .help-block
                    p.bcard-comments.text-info
                      | ※ 「企業内組織コード」を選択すると、「所属組織」の「企業内組織コード」が未設定の組織は、「組織システムID」が出力されます。

        +btnbar

      .callout.callout-info.bcard-callout
        p ※ エクスポートする項目の順番をドラッグ＆ドロップで変更できます。
          br
          | ※ 変更した項目の順番はエクスポートが正しく終了した場合に保存され、インポートの項目の順番も同様となります。

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- エクスポート中
    app-modal(v-model="modalExporting" type="info" :showClose="showClose")
      template(slot="title") エクスポート実行中
      h4
        i.icon.fa.fa-spinner.fa-pulse
        | &nbsp;ただいまCSVファイルへエクスポート中です。
      p エクスポートには時間がかかることがあります。しばらくお待ちください。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(@click="cancel(); close()") キャンセル

    //- 成功
    app-modal(v-model="modalExportSuccess" type="success")
      template(slot="title") エクスポート完了
      h4 CSVファイルのエクスポートが完了しました。
      p [ダウンロード]ボタンをクリックしてファイルをダウンロードしてください。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-primary(type="button" @click="download()")
          i.fa.fa-download
          |  ダウンロード
        button.btn.btn-default(type="button" @click="close()") 閉じる

    //- 失敗
    app-modal(v-model="modalExportError" type="warning")
      template(slot="title") エクスポートエラー
      h4 CSVファイルのエクスポートに失敗しました。
      p エラーメッセージ: {{message}}
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(type="button" @click="close()") 閉じる

    //- キャンセル
    app-modal(v-model="modalExportCancel")
      template(slot="title") エクスポート中止
      h4 CSVファイルのエクスポートを中止しました。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-default(type="button" @click="close()") 閉じる

</template>

<script>
import draggable from 'vuedraggable'
import mixinImportExport from '@/mixins/importExport'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import ExportSettings from '@/components/organisms/ExportSettings'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const GroupRepository = RepositoryFactory.get('group')

export default {
  name: 'GroupExport',
  components: { draggable, AppModal, AppMessages, ExportSettings },
  mixins: [ mixinImportExport ],
  data: function () {
    return {
      imexfld: [], // 表示する項目の順番

      message: '', // エラーダイアログに表示するメッセージ
      groupvalkind: 'i',
      isDownloading: false, // ダウンロード中
      showClose: false, // [×]ボタン表示フラグ
      // 結果取得フラグ
      isGodResult: null, // 初期値：null, 取得完了：true, 取得中：false

      // 各モーダルオープンフラグ
      modalExporting: false,
      modalExportSuccess: false,
      modalExportError: false,
      modalExportCancel: false
    }
  },
  created: function () {
    // 項目の順番を設定する
    this.setImexfld()
  },
  methods: {
    /*
     * 項目の順番を設定する
     */
    setImexfld: function () {
      this.imexfld = this.comSetImexfld('group')
    },
    /*
     * 項目の順番を規定値に戻す
     */
    resetImexfld: function () {
      // imexfldの内容をpresetの値に置き換える
      this.imexfld = this.comSetImexfld('group', true)
    },
    exportAction: function () {
      const vm = this
      this.modalExporting = true

      const formData = new FormData(this.$refs.form)
      // API実行
      GroupRepository.postExport(formData)
        .then(function (response) {
          // エクスポート処理結果取得処理
          vm.exportResult()
        })
        .catch(function (error) {
          // エラーメッセージを設定
          vm.message = error.response.data.data.message

          vm.modalExporting = false
          vm.modalExportError = true
        })

      // ExportSettingsのsaveCookie()を呼び出す
      this.$refs.exportSettings.saveCookie()
      // 項目の順番をCookieに保存する
      this.comSaveCookie('group', this.imexfld)
    },
    exportResult: function () {
      const vm = this

      // 1秒置きにエクスポート処理結果取得処理を実行する
      const getResult = setInterval(function () {
        // 前回の結果取得が終わっていない場合、結果取得を行わない
        if (vm.isGodResult === false) {
          return
        }

        // 結果取得フラグをオフにする
        vm.isGodResult = false
        GroupRepository.getExportResult()
          .then(function (response) {
            // 処理結果：正常
            if (response.data.success) {
              // 「処理中」以外
              if (response.data.status !== 'active') {
                // 結果取得処理を止める
                clearInterval(getResult)
              }

              // 正常終了
              if (response.data.status === 'finish') {
                vm.modalExporting = false
                vm.modalExportSuccess = true
              }
              // キャンセル
              else if (response.data.status === 'cancel') {
                vm.modalExporting = false
                vm.modalExportCancel = true
              }
            }
            // 処理結果：失敗
            else {
              // 結果取得処理を止める
              clearInterval(getResult)
              // エクスポートエラーの出力
              vm.outputError(response.data.message)
            }
          })
          .catch(function (error) {
            clearInterval(getResult)
            // エクスポートエラーの出力
            vm.outputError(error.response.data.data.message)
          })
          .finally(function () {
            // 結果取得フラグをオンにする
            vm.isGodResult = true
          })
      }, this.app_interval.getResult)
      this.$store.commit('setIntervals', getResult)
    },
    /**
     * エクスポートエラーの出力
     * @param String message エラーメッセージ
     */
    outputError: function (message) {
      // エラーメッセージを設定
      this.message = message

      this.modalExporting = false
      this.modalExportError = true
    },
    download: function () {
      const vm = this
      // ダウンロード中ではない場合のみ実行する
      if (this.isDownloading === false) {
        this.isDownloading = true

        // ダウンロード処理を行う
        this.getFileDL('group', 'getExport', 'group_export.csv')
          .catch(function (error) {
            vm.setErrorMessage(error)
          })
          .finally(function () {
            vm.isDownloading = false
          })
      }
    },
    cancel: function () {
      const vm = this
      // エクスポートキャンセル処理を実行
      GroupRepository.cancelExport()
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  tr {
    cursor: move;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/group/Export.vue